export default __webpack_public_path__ + "static/media/spid-idp-sielteid.61237023.png";